import * as React from 'react';
import classNames from 'classnames';
import { SOCIALS_SETTINGS_MAP } from './constants';
import * as styles from './SocialButton.css';
import * as buttonStyles from '../../styles/button.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function SocialButton(_ref) {
  var type = _ref.type,
    onClick = _ref.onClick;
  var settings = SOCIALS_SETTINGS_MAP[type];
  var handleClick = React.useCallback(function () {
    return onClick(type);
  }, [type, onClick]);
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    title: settings.title,
    "data-mark": "SocialBtn".concat(type[0].toUpperCase()).concat(type.slice(1).toLowerCase()),
    className: classNames(buttonStyles['button'], styles['button'], settings.className),
    style: {
      backgroundImage: "url(\"".concat(settings.icon, "\")")
    },
    onClick: handleClick
  });
}